import {
  FilterOption,
  FilterViewModel,
} from '../../../ViewModel/filterViewModel/filterViewModel';

export const getSelectedOptionsFromList = (list: FilterOption[]) =>
  list.filter((option) => option.selected);

export const optionsHaveChildren = (options: FilterOption[]) =>
  options[0]?.children !== undefined;

export function getSelectedOptions({ options }: FilterViewModel) {
  return optionsHaveChildren(options)
    ? options.reduce(
        (acc, option) =>
          acc.concat(getSelectedOptionsFromList(option.children!)),
        [] as FilterOption[],
      )
    : getSelectedOptionsFromList(options);
}

export const toggleOptionInList = (
  list: FilterOption[],
  clickedOption: FilterOption,
  maxOptionsToSelect: number | undefined = undefined,
) =>
  maxOptionsToSelect === 1
    ? [clickedOption]
    : clickedOption.selected
    ? list.filter(
        (option) => option.selected && option.value !== clickedOption?.value,
      )
    : list.filter(
        (option) => option.selected || option.value === clickedOption?.value,
      );
